import React, { Component } from "react";
import classnames from "classnames";


class SettingsMenu extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		isMarketplaceUser: JSON.parse(localStorage.getItem('userData')).isMarketplaceUser
    }
	
}
 
componentDidMount(){
	
}

setUserInfoAsPrevious=(e)=>{
	if ( this.props.state.chosenMenu != 'Personal Info' )
		{
			this.props.updateStateFromChild({chosenMenu: 'Personal Info'});
			this.props.resetUserInfo();
		}
	
}

  render() {
	 return (
		<div className="settings_menu_content">
			<div className={classnames({'settings_menu_option': true, 'active': this.props.chosenMenu == 'Personal Info'})} onClick={(e) => this.setUserInfoAsPrevious({e})}>Personal Info</div>
			<div className={classnames({'settings_menu_option': true, 'active': this.props.chosenMenu == 'Fitness Info'})} onClick={() => this.props.updateStateFromChild({chosenMenu: 'Fitness Info'})}>Fitness Info</div>
			<div className={classnames({'settings_menu_option': true, 'active': this.props.chosenMenu == 'Email Notifications'})} onClick={() => this.props.updateStateFromChild({chosenMenu: 'Email Notifications'})}>Email Notifications</div>
			{ this.state.isMarketplaceUser == 1 &&
				<div className={classnames({'settings_menu_option': true, 'active': this.props.chosenMenu == 'Account Security'})} onClick={() => this.props.updateStateFromChild({chosenMenu: 'Account Security'})}>Account Security</div>
			}
		</div>
    );
  }
}
export default SettingsMenu;
